// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .content[data-v-82a0224a]{padding-left:16px;padding-right:16px}#app .content .content-title[data-v-82a0224a]{text-align:left}#app .content .videoBox[data-v-82a0224a]{width:100%;padding:16px 0}#app .content .sTime[data-v-82a0224a]{display:block;text-align:left;padding-top:10px;color:#999;font-size:14px}", ""]);
// Exports
module.exports = exports;
